import NotificationItemTemplate from '../../../ui-kit/components/templates/NotificationItemTemplate'
import UserAvatar from '../../../ui-kit/components/atoms/UserAvatar'

const UserNotification = ({unread}) => {
  return (
    <NotificationItemTemplate
      unread={unread}
      graphic={<UserAvatar />}
      title="José López"
      caption="ha realizado una nueva publicación."
      time="Hace 22 minutos"
    />
  )
}

export default UserNotification
